export default {
  types: {
    all: 'All',
    visited: 'Visited',
    favorites: 'Favorites'
  }
}
